
import { defineComponent, PropType } from 'vue';
import HeroBannerHandler from '@/shared/content/blocks/hero-banner/HeroBannerHandler.vue';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { StoreContextContentPageContent } from '@/types/StoreContextContentServerContract';

export default defineComponent({
    name: 'StoreContextContentPage',
    components: { BlockList, HeroBannerHandler },
    props: {
        content: {
            type: Object as PropType<StoreContextContentPageContent>,
            required: true,
        },
    },
});
